// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "sender_name": {
      "column": {
        "default": "SKOLEELEVER",
        "name": "sender_name",
        "null": false,
        "type": "string"
      },
      "name": "sender_name",
      "selected_by_default": null,
      "translated": null
    },
    "simple_text": {
      "column": {
        "default": null,
        "name": "simple_text",
        "null": true,
        "type": "text"
      },
      "name": "simple_text",
      "selected_by_default": null,
      "translated": null
    },
    "subject": {
      "column": {
        "default": null,
        "name": "subject",
        "null": false,
        "type": "string"
      },
      "name": "subject",
      "selected_by_default": null,
      "translated": null
    },
    "text": {
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      },
      "name": "text",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Template",
  "collectionKey": "templates",
  "collectionName": "templates",
  "i18nKey": "template",
  "camelizedLower": "template",
  "name": "Template",
  "nameDasherized": "template",
  "pluralName": "templates",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "SendingRule",
      "collectionName": "sending_rules",
      "foreignKey": "template_id",
      "name": "sending_rules",
      "macro": "has_many",
      "resource_name": "SendingRule",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "sender_name",
      "column": {
        "default": "SKOLEELEVER",
        "name": "sender_name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "simple_text",
      "column": {
        "default": null,
        "name": "simple_text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "subject",
      "column": {
        "default": null,
        "name": "subject",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "text",
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "template",
  "primaryKey": "id"
}

/** Frontend model for Template. */
export default class Template extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  senderName() {
    return this.readAttributeUnderscore("sender_name")
  }

  /** @returns {boolean} */
  hasSenderName() {
    const value = this.senderName()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  simpleText() {
    return this.readAttributeUnderscore("simple_text")
  }

  /** @returns {boolean} */
  hasSimpleText() {
    const value = this.simpleText()

    return this._isPresent(value)
  }

  /** @returns {string} */
  subject() {
    return this.readAttributeUnderscore("subject")
  }

  /** @returns {boolean} */
  hasSubject() {
    const value = this.subject()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  text() {
    return this.readAttributeUnderscore("text")
  }

  /** @returns {boolean} */
  hasText() {
    const value = this.text()

    return this._isPresent(value)
  }
}
